import { useSelector } from 'react-redux';

export const useHolocronState = () => useSelector((state) => state);
